import { T as t } from "./Textfield-C8VVehBj.js";
import { d as m } from "./define-element-Dl91r6Vu.js";
m("sp-textfield", t);
//# sourceMappingURL=sp-textfield-BV3XNpg3.js.map
